import { Button } from "antd";
import AboutUs from '../assets/BABCAWS2E_Manual.pdf'
import { CONSTANTS } from "../utils/constants";
import Gene from "../assets/Gene.jpg";
import Martine from "../assets/Martine.jpg";
import GeneMartine from "../assets/image001.png";

const About = () => {

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = AboutUs;
    link.download = "BABCAWS2E_Manual.pdf";
    link.click();
  };

  return (
    <div className="min-h-[calc(100vh-133px)] px-3">
      <div>
        <div>
          <div className="text-center mt-4">
            <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900">{CONSTANTS.ABOUTBAB}</h1>
            <div className="my-6">
              <Button
                onClick={handleDownload}
                size="large"
                type="primary"
              >
                {CONSTANTS.DOWNLOADMANUAL}
              </Button>
            </div>
          </div>

          {/* Content area - text taken from the uploaded Word document */}
          <main>
            <article className="prose prose-lg prose-indigo max-w-none text-gray-700">
              <p className="leading-relaxed text-justify">
              The <i>Behavior Assessment Battery for Children and Adolescents Who Stutter, Second Edition (BAB)</i> is a fully <strong>web-based</strong>, research-based assessment instrument designed to evaluate the affective, behavioral, and cognitive reactions of school-age children and adolescents who stutter. The BAB offers a multidimensional profile of how children and adolescents feel about, react to, and think about their speech and communication.
              </p>
              <br/>
              <p className="leading-relaxed text-justify">
                Building on decades of research and worldwide clinical use, this new online-only edition updates the original print package with an intuitive user interface, automated scoring, and immediate interpretation of the self-report test results. Clinicians simply log in, complete the questionnaires with their client, and receive results instantly—no manual scoring, norm-table lookups, or separate scoring keys required. Each score is automatically analyzed for clinical significance, streamlining decision-making and supporting evidence-based therapy planning.
              </p>
              <br/>
              <h2><strong>Components of the BAB:</strong></h2>
              <p className="leading-relaxed">The BAB includes four self-report tests:</p>
              <br/>
              <ul className="list-disc list-inside leading-relaxed">
                <li>
                  <strong>Speech Situation Checklist – Emotional Reaction (SSC-ER):</strong> Evaluates the child’s emotional response across a variety of speaking situations.
                </li>
                <li>
                  <strong>Speech Situation Checklist – Speech Disruption (SSC-SD):</strong> Measures the degree of speech disruption a child anticipates or experiences in those same situations.
                </li>
                <li>
                  <strong>Behavior Checklist (BCL):</strong> Identifies the coping responses and strategies a child uses to avoid or escape stuttering.
                </li>
                <li>
                  <strong>Communication Attitude Test (CAT):</strong> Assesses the child’s overall attitude toward their speech and communication abilities.
                </li>
              </ul>
              <br/>
              <p className="leading-relaxed">Together, these procedures give clinicians a clear, multidimensional understanding of the clients’ internal experience related to stuttering.</p>
              <br/>
              <h2><strong>Clinical Use and Interpretation:</strong></h2>

              <p className="leading-relaxed">
                The BAB provides an "inside view" of a child's speech-related feelings, reactions, and attitude, complementing observable behaviors gathered from traditional fluency assessments. By examining total and item-level scores across the SSC-ER, SSC-SD, BCL, and CAT, clinicians can:
              </p>
              <br/>
              <ul className="list-disc list-inside leading-relaxed">
                <li>Identify the emotional, behavioral and cognitive factors that might be part of the <i>person</i> who stutters</li>
                <li>Determine areas of vulnerability and resilience</li>
                <li>Guide the selection of treatment strategies and therapeutic goals</li>
                <li>Serve as outcome measure - monitor change over time and measure progress</li>
              </ul>
              <br/>
              <p className="leading-relaxed">The sub-tests of the BAB for Children and Adolescents who Stutter have been updated since the 2007 publication to reflect changes in daily life. In addition, items that were redundant have been removed to shorten the self-report tests, and the item wording of the CAT has been simplified. New normative data have been gathered.</p>
              <br/>
              <p className="leading-relaxed">The online platform eliminates the need for print manuals, scoring keys, norm sheets, or boxed test forms. Every step—from administration to interpretation—is handled digitally.</p>

              {/* Authors section */}
              <section className="mt-12">
                <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 text-center">About the Authors</h2>

                <div className="mt-3 grid grid-cols-1 lg:grid-cols-2 gap-8">
                  <div className="flex flex-col gap-4 items-start bg-white p-5 rounded-lg shadow-sm">
                    <img
                      src={Martine}
                      alt="Martine Vanryckeghem"
                      className="w-full object-cover rounded-md flex-shrink-0"
                    />
                    <div className="text-sm text-gray-700">
                      <h3 className="text-lg font-medium text-gray-900">Martine Vanryckeghem, PhD</h3>
                      <p className="mt-2 leading-relaxed text-justify">
                        Martine Vanryckeghem, PhD received her Master's Degree (1991) and PhD (1994) from Southern Illinois University, Carbondale, after having worked for 12 years as a speech-language pathologist at a Clinical Center in Belgium. Dr. Vanryckeghem started her academic career at the University of Central Florida (UCF) in 1994. She is clinically certified as a speech-language pathologist, is an ASHA Fellow, a Board Certified Specialist in Stuttering, Cluttering, and Fluency Disorders and European Fluency Specialist. She has published widely in peer-reviewed journals and has given lectures and workshops, internationally, with respect to the assessment and treatment of children and adults who stutter. She is the co-author of the Behavior Assessment Battery (BAB) for Children and Adolescents who Stutter, the Behavior Assessment Battery (BAB) for Adults who Stutter, and the Communication Attitude Test for Preschoolers and Kindergartners who Stutter (KiddyCAT) which have been researched in 30+ countries. For her international endeavors, Prof. Vanryckeghem received ASHA's Certificate of Recognition for Outstanding Contribution in International Achievement and is a Fulbright recipient. From 1990 until 2000, she was managing editor of the Journal of Fluency Disorders and is an editorial board member for several professional journals. Dr. Vanryckeghem is on the Scientific Board of different internationally-based organizations and serves as a consultant to faculty and students. She has been a guest professor at the University of Gent, Belgium and the University of Utrecht, the Netherlands. She is a faculty member, coach and partner of the post-graduate European Stuttering Specialization (ESS) course. In August 2025, Dr. Vanryckeghem became Pegasus Professor Emerita at UCF.
                      </p>
                    </div>
                  </div>

                  <div className="flex flex-col gap-4 items-start bg-white p-5 rounded-lg shadow-sm">
                    <img
                      src={Gene}
                      alt="Gene J. Brutten"
                      className="w-full object-cover rounded-md flex-shrink-0"
                    />
                    <div className="text-sm text-gray-700">
                      <h3 className="text-lg font-medium text-gray-900">Gene J. Brutten, PhD</h3>
                      <p className="mt-2 leading-relaxed text-justify">
                        Gene J. Brutten, PhD received his PhD from the University of Illinois, and was clinically certified in speech pathology and audiology by the American Speech-Language-Hearing Association. He was a fellow of the association and was awarded its Certificate of Recognition and Certificate of Appreciation. Professor Brutten was a founding member of the International Fluency Association and served as the editor-in-chief of its Journal of Fluency Disorders from 1989 to 2000. In 1971 and again in 1978, he received a Fulbright-Hays award to the Department of Foniatrie at the University of Utrecht Academic Hospital, the Netherlands, where he conducted clinically-based research. He co-authored the seminal book "Modification of Stuttering," has published more than 80 peer-reviewed journal articles, 20 book chapters, and has given over 200 professional presentations in three continents on differential assessment and behavior therapy. Dr. Brutten was an emeritus professor in the Southern Illinois University Department of Communication Disorders and Sciences, where he served as department chair, and in its Department of Psychology. In 2002, Dr. Brutten received the Honors of the American Speech-Language-Hearing Association, and in 2009, he was similarly honored by the International Fluency Association. Dr. Brutten passed away in March 2013.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="my-8 flex flex-col items-center text-center">
                  <div className="mt-4 inline-block rounded-lg overflow-hidden">
                    <img
                      src={GeneMartine}
                      alt="Martine and Gene"
                      className="w-full lg:w-1/3 object-cover block mx-auto"
                    />
                  </div>
                  <i className="mt-3">~ Gene & Martine ~</i>
                </div>
              </section>
            </article>
          </main>
        </div>
      </div>
    </div>
  );
}
export default About;